import { FormOfferProvider } from './../../../../context/FormOfferContext';
import EditOffer from './EditOffer';

function UpdateOffer() {
  return (
    <FormOfferProvider>
      <EditOffer />
    </FormOfferProvider>
  );
}

export default UpdateOffer;